import React, { useState, useRef } from 'react';
import './HireMe.scss';
import axios from 'axios';
// captcha

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import ReCAPTCHA from "react-google-recaptcha";

// import emailjs from 'emailjs-com';
import emailjs from '@emailjs/browser';

// emailjs.init('YOUR_USER_ID');
// NodeMailer or EmaiJS

export default function HireMe() {
  // const handleFormSubmit = (event) => {
  //   event.preventDefault();

  //   // Get form data (recipient's email, subject, message, and attachment)

  //   const templateParams = {
  //     to_email: 'recipient@example.com',
  //     subject: 'Email Subject',
  //     message: 'Email Message',
  //     attachment: event.target.attachment.files[0], // Assuming "attachment" is the name of your file input
  //   };

  //   emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', templateParams)
  //     .then((response) => {
  //       console.log('Email sent!', response.status, response.text);
  //     }, (error) => {
  //       console.error('Error sending email:', error);
  //     });
  // };



  // const [email, setEmail] = useState('');

  // const handleForm = async (event) => {
  //   event.preventDefault();

  //   try {
  //     // Send email with PDF attachment
  //     console.log(email)
  //     await axios.post('/send-email', { email });

  //     // Display success message
  //     alert('Email sent successfully');
  //   } catch (error) {
  //     // Display error message
  //     alert('Error! Please directly email me.');
  //   }
  // };

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_7twmfst', 'template_jw43bof', form.current, 'Po5BCYqPOKK8wOyJt')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
  };



  const [recaptchaResponse, setRecaptchaResponse] = useState("");
  const handleSubmit = () => {
    if (recaptchaResponse) {
      // do something
    } else {
      alert("Please verify that you're not a robot.");
    }
  };

  return (
    <>
      <div className='hire-me-layer'>
        <div className="section-title-div">
          <h3 className='div-title'><span>H</span>IRE ME</h3>
          <div className="div-centered-text">
            Request for resume
          </div>
        </div>

        <div className='hire-me-form'>
          <p>Automatically send my resume to your email by filling up the inputs bellow.</p>
          <form ref={form} onSubmit={sendEmail}>
            <div className='row mb-2'>
              <div className='col-6'>
                <label for="hire-me-email">Email *</label>
                <input required placeholder='your@email.com' id="hire-me-email" name="hire-me-email" className="hire-me-email" />
                {/* onChange={(event) => setEmail(event.target.value)} */}
              </div>
              <div className='col-6'>
                <label for="hire-me-name">Name</label>
                <input id='hire-me-name' className='hire-me-name' type="text" name="hire-me-name" placeholder="Your name" />
              </div>
            </div>

            <div className='hire-me-msg'>
              <label for="hire-me-message">Message</label>
              <textarea id='hire-me-message' className='hire-me-message' name="hire-me-message" placeholder="Your message"></textarea>
            </div>


            <div className='row pb-2'>
              <div className="
          col-lg-8
          col-md-8
          col-sm-8
          col-xs-12">
                <ReCAPTCHA required className='recaptcha'
                  sitekey={process.env.REACT_APP_CAPTCHA}
                  onChange={(response) => setRecaptchaResponse(response)}
                />
              </div>
              <div className="
          col-lg-4
          col-md-4
          col-sm-4
          col-xs-12">

                <button type="submit" className='hire-me-send' id="hire-me-send">Submit</button>
              </div>
            </div>
          </form>
        </div >
      </div >
    </>
  )
}